import Vue from "vue";
import VueRouter from "vue-router";
import { constantRoutes } from "./routerConfig";
import { showSingleMessage } from "@/utils/messageOnce";
import store from "@/store";
import { getBranding } from "@/config/branding";
import i18n from '@/i18n'
import { getRouteTitle } from './i18nUtil'

Vue.use(VueRouter);
const router = new VueRouter({
  routes: [...constantRoutes],
  mode: "history",
});

let permissionLoading = null;
let permissionLoadingToken = null;

// 解决跳转路径和当前路径重复，报错问题
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};
router.beforeEach(async (to, from, next) => {
  const token = Vue.ls.get("ACCESS_TOKEN");
  const branding = getBranding();
  const sysName = branding.sysName || process.env.VUE_APP_API_SYS_NAME;
  // 路由标题：按当前语言读取 menu.i18n.js（页面名 / Page title）
  const routeTitle = getRouteTitle(to, i18n.language)
  document.title = routeTitle ? `${routeTitle}-${sysName}` : sysName;
  const isLoginPage = to.path === "/login";
  if (isLoginPage && token) {
    const redirectPath = to.query.redirect || "/home";
    next(redirectPath);
    return;
  }
  if (!token && isLoginPage) {
    store.dispatch("permission/ResetPermission");
    next();
    return;
  }
  if (!token) {
    store.dispatch("permission/ResetPermission");
    store.dispatch("app/resetAfterLogout");
    if (to.path !== "/login") {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
    return;
  }

  if (!store.getters["permission/isLoaded"]) {
    try {
      if (!permissionLoading || permissionLoadingToken !== token) {
        permissionLoadingToken = token;
        permissionLoading = store.dispatch("permission/GenerateRoutes");
      }
      const dynamicRoutes = await permissionLoading;
      if (Vue.ls.get("ACCESS_TOKEN") !== token) {
        return;
      }
      permissionLoading = null;
      permissionLoadingToken = null;
      if (Array.isArray(dynamicRoutes) && dynamicRoutes.length) {
        const existingPaths = router.getRoutes
          ? router.getRoutes().map((r) => r.path)
          : router.options.routes.map((r) => r.path);
        const freshRoutes = dynamicRoutes.filter(
          (route) => route && !existingPaths.includes(route.path)
        );
        if (freshRoutes.length) {
          router.addRoutes(freshRoutes);
          router.options.routes = router.options.routes.concat(freshRoutes);
        }
      }
      next({ ...to, replace: true });
      return;
    } catch (error) {
      const tokenStillValid = Vue.ls.get("ACCESS_TOKEN") === token;
      if (!tokenStillValid) {
        next(false);
        return;
      }
      permissionLoading = null;
      permissionLoadingToken = null;
      // 接口返回体中的登录失效已在 request 拦截器里 showSingleMessage，此处不再重复提示
      if (error !== "error") {
        showSingleMessage({
          message: "加载菜单失败，请重新登录",
          type: "error",
        });
      }
      store.dispatch("permission/ResetPermission");
      store.dispatch("app/resetAfterLogout");
      store.commit("user/CLEAR_USER", { redirect: false });
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
      return;
    }
  }

  next();
});

export default router;
